import { createActionHandler, createReducer } from '@pressreader/appstore';
import { AnyPopup } from '@pressreader/popups-types';

import { baselinePopupClosed, baselinePopupOpened, popupChanged, popupClosed, popupOpened } from './actions';

interface IState {
    popups: AnyPopup[];
    /**
     * Popups that are shown in baseline mode (under the overlay)
     * They always overlay FaceLift popups.
     */
    baselinePopups: Array<{
        id: string;
        type: AnyPopup['type'];
    }>;
}

const initialState: IState = {
    popups: [],
    baselinePopups: [],
};

const reducer = createReducer<IState>(
    initialState,
    createActionHandler(popupOpened, (state, { payload }) => ({
        ...state,
        popups: [...state.popups, payload.popup],
    })),
    createActionHandler(popupClosed, (state, { payload }) => ({
        ...state,
        popups: state.popups.filter(popup => popup.id !== payload.id),
    })),
    createActionHandler(popupChanged, (state, { payload }) => {
        const { popup } = payload;
        const idx = state.popups.findIndex(p => p.id === popup.id);
        if (idx < 0) {
            return state;
        }
        const popups = [...state.popups];
        popups[idx] = popup;
        return {
            ...state,
            popups,
        };
    }),
    createActionHandler(baselinePopupOpened, (state, { payload }) => ({
        ...state,
        baselinePopups: state.baselinePopups.some(popup => popup.id === payload.id) ? state.baselinePopups : [...state.baselinePopups, payload],
    })),
    createActionHandler(baselinePopupClosed, (state, { payload }) => ({
        ...state,
        baselinePopups: state.baselinePopups.filter(popup => popup.id !== payload.id),
    })),
);

export { IState, reducer };
